<template>
  <div class="course p_t">
    <TopHead title="场馆介绍"></TopHead>
    <van-pull-refresh v-model="loading" @refresh="onRefresh">
      <van-list
        :immediate-check="false"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <ul class="list">
          <li v-for="item in list" :key="item.contentId">
            <img :src="item.coverUrl" class="bj" alt>
            <div class="mask" @click="detail(item.contentId)">
              <!-- <img src="../assets/images/icon6.png" class="icon" alt=""> -->
              <p>{{item.tags[0]}}</p>
              <h6>{{item.title}}</h6>
              <span>
                查看
                <van-icon name="arrow" color="#fff"/>
              </span>
            </div>
          </li>
        </ul>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
export default {
  data() {
    return {
      params: {
        pageIndex: 1,
        pageSize: 6,
        columnCode: ""
      },
      list: [],
      refreshing: false,
      loading: true,
      finished: false
    };
  },
  created() {
    this.params.columnCode = this.$route.query.code;
    this.getList();
  },
  methods: {
    detail(item) {
      this.$router.push(`/VenueDetail?contentId=${item}`);
    },

    getList() {
      this.$api.listContent(this.params).then(res => {
        this.loading = false;
        if (this.refreshing) {
          this.refreshing = false;
        }
        if (res.data.recordCount) {
          this.list = this.list.concat(
            JSON.parse(JSON.stringify(res.data.rows))
          );
        }
        let list = res.data.rows;
        if (!list || list.length < this.params.pageSize) {
          this.finished = true;
        }
      });
    },
    onRefresh() {
      this.list = [];
      this.finished = false;
      this.params.pageIndex = 1;
      this.getList();
    },
    onLoad() {
      let me = this;
      if(me.loading) return
      let page = me.params.pageIndex;
      page = page ? page + 1 : 1;
      this.params.pageIndex = page;
      this.getList();
    }
  }
};
</script>
<style lang="scss" scoped>
.list {
  padding-top: 14px;
}
.list li {
  position: relative;
  width: 350px;
  height: 185px;
  margin: 0 auto 20px;
  border-radius: 6px;
  overflow: hidden;
  .bj {
    position: absolute;

    left: 0;
    top: 0;
    width: 100%;
    display: block;
    height: 100%;
    z-index: -1;
  }
  .mask {
    width: 324px;
    padding-top: 30px;
    box-sizing: border-box;
    border-radius: 6px;
    height: 150px;
    margin: 18px auto 0;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    text-align: center;
    img {
      width: 45px;
      height: 45px;
      border-radius: 50%;
    }
    p {
      font-size: 12px;
      margin-top: 2px;
      margin-bottom: 4px;
    }
    h6 {
      border-top: 2px solid #ffffff;
      width: 126px;
      padding-top: 5px;
      font-size: 18px;
      margin: 0 auto;
    }
    span {
      display: block;
      margin-top: 18px;
    }
  }
}
</style>
